import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  updateNodeFuctionalText,
  updateNodeFunctionalLevel,
  resetFilterSideBar,
} from "redux/actions";

const HIDE_SUB_SUB_CHILD = false

const ChildItem = ({ item, onClick, querySearchKey, level = 0 }) => {
  const dispatch = useDispatch();
  const [isChildNodesOpen, setIsChildNodesOpen] = useState(false);
  let setSearchParams = useSearchParams()[1];

  const { nodeFunctionalText, nodeFunctionalLevel } = useSelector(
    ({ product }) => product
  );

  const handleNodeChange = (
    e,
    text,
    funtional_level,
    function_names,
    category_ids
  ) => {
    dispatch(updateNodeFuctionalText(text));
    dispatch(updateNodeFunctionalLevel(funtional_level));
    if (querySearchKey === "category_ids") {
      setSearchParams({ category_ids: category_ids });
    } else {
      setSearchParams({ function_names: function_names });
    }
  };

  const handleToggleExpand = (e) => {
    e.stopPropagation();
    setIsChildNodesOpen(!isChildNodesOpen);
  };

  const handleItemClick = (e) => {
    handleNodeChange(
      e,
      item.text,
      item.funtional_level,
      item.function_names,
      item.category_ids
    );
    if (item.node && item.node.length > 0) {
      setIsChildNodesOpen(true);
    }
  };

  return (
    <div>
      <div
        className={
          nodeFunctionalText === item.text &&
          nodeFunctionalLevel === item.funtional_level
            ? "department-item active"
            : "department-item"
        }
        onClick={handleItemClick}
        key={item.category_ids}
      >
        <div className="title-alignment">
          <div>
            {item.text} 
            {/* {item.product_count !== "0" ? `(${item.product_count})` : ""} */}
          </div>
        </div>
        { !HIDE_SUB_SUB_CHILD && item.node && item.node.length !== 0 && (
          <div
            onClick={handleToggleExpand}
          >
            {isChildNodesOpen ? <PlusSignIcon /> : <MinusSignIcon />} 
          </div>
        )}
      </div>
      
      {HIDE_SUB_SUB_CHILD ? null : <div className="child-department-list">
        {isChildNodesOpen &&
          item.node &&
          item.node.map((childItem, index) => (
            <ChildItem
              key={index}
              item={childItem}
              onClick={onClick}
              querySearchKey={querySearchKey}
              level={level + 1}
            />
          ))}
      </div>}
    </div>
  );
};

const Item = (props) => {
  const {
    node,
    onClick,
    isChildNodesOpenDefault,
    category_ids,
    slug,
    text,
    product_count,
    isRootItem,
    funtional_level,
    function_names,
    redirectBaseUrl,
    querySearchKey,
  } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const [isChildNodesOpen, setIsChildNodesOpen] = useState(isChildNodesOpenDefault);

  let setSearchParams = useSearchParams()[1];

  const { nodeFunctionalText, nodeFunctionalLevel } = useSelector(
    ({ product }) => product
  );

  const handleClickRedirect = () => {
    if (params?.departmentSlug !== slug) {
      navigate(`/${redirectBaseUrl}/${slug}`);
    }
    dispatch(resetFilterSideBar());
    setIsChildNodesOpen(!isChildNodesOpen);
  };

  const handleNodeChange = (
    e,
    text,
    funtional_level,
    function_names,
    category_ids
  ) => {
    dispatch(updateNodeFuctionalText(text));
    dispatch(updateNodeFunctionalLevel(funtional_level));
    if (querySearchKey === "category_ids") {
      setSearchParams({ category_ids: category_ids });
    } else {
      setSearchParams({ function_names: function_names });
    }
  };

  const handleItemClick = (e) => {
    setIsChildNodesOpen(!isChildNodesOpen);
    if (isRootItem) {
      handleClickRedirect();
    } else {
      handleNodeChange(
        e,
        text,
        funtional_level,
        function_names,
        category_ids
      );
      if (node && node.length > 0) {
        setIsChildNodesOpen(!isChildNodesOpen);
      }
    }
  };

  return (
    <div>
      <div
        className={
          isChildNodesOpenDefault ||
          (nodeFunctionalText === text &&
            nodeFunctionalLevel === funtional_level)
            ? "department-item active"
            : "department-item"
        }
        onClick={handleItemClick}
        key={category_ids}
      >
        <div className="title-alignment">
          <div>
            {text} 
            {/* {product_count !== "0" ? `(${product_count})` : ""} */}
          </div>
        </div>
        {node?.length && (
          <span style={{ cursor: "pointer", width: "16px", height: "16px" , padding: "0"}}>
            {isChildNodesOpen ? (
              <PlusSignIcon />
            ) : (
              <MinusSignIcon />
            )}
          </span>
        )}
      </div>

      <div className="child-department-list">
        {isChildNodesOpen &&
          node &&
          node.map((item, index) => (
            <ChildItem
              key={index}
              item={item}
              onClick={onClick}
              querySearchKey={querySearchKey}
            />
          ))}
      </div>
    </div>
  );
};

const DepartmentListItem = React.memo(
  ({ departmentTree, redirectBaseUrl, querySearchKey }) => {
    const [departmentTreeList, setDepartmentTree] = useState(departmentTree);

    const { departmentSlug } = useParams();

    useEffect(() => {
      setDepartmentTree(departmentTree);
    }, [departmentTree]);

    return (
      <div>
        {departmentTreeList
          ? departmentTreeList.map((item, index) => (
              <Item
                key={index}
                isRootItem={true}
                isChildNodesOpenDefault={departmentSlug === item.slug}
                {...item}
                redirectBaseUrl={redirectBaseUrl}
                querySearchKey={querySearchKey}
              />
            ))
          : ""}
      </div>
    );
  }
);

function PlusSignIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="var(--primary-color)"
    >
      <rect x="2" y="7" width="12" height="2" />
    </svg>
  )
}

function MinusSignIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="var(--primary-color)"
    >
      <rect x="7" y="2" width="2" height="12" />
      <rect x="2" y="7" width="12" height="2" />
    </svg>
  )
}

export default DepartmentListItem;
